export { default } from './Col2TextText'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/Col2TextText/index.js